import { analyticsClient } from "./analyticsClient/analyticsClient";
import { analyticsClientStub } from "./analyticsClient/stub";
export var legacyClients = {
    analyticsClient: analyticsClient
};
export var legacyClientsStub = {
    analyticsClient: analyticsClientStub
};
